import { render } from "./SnackBarGlobal.vue?vue&type=template&id=6c927693"
import script from "./SnackBarGlobal.vue?vue&type=script&lang=js"
export * from "./SnackBarGlobal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__